export default __webpack_public_path__ + "static/media/battleship.d1f2031d.png";